let wasm;

const heap = new Array(128).fill(undefined);

heap.push(undefined, null, true, false);

let heap_next = heap.length;

function addHeapObject(obj) {
    if (heap_next === heap.length) heap.push(heap.length + 1);
    const idx = heap_next;
    heap_next = heap[idx];

    heap[idx] = obj;
    return idx;
}

function getObject(idx) { return heap[idx]; }

function dropObject(idx) {
    if (idx < 132) return;
    heap[idx] = heap_next;
    heap_next = idx;
}

function takeObject(idx) {
    const ret = getObject(idx);
    dropObject(idx);
    return ret;
}

function isLikeNone(x) {
    return x === undefined || x === null;
}

let cachedBigInt64Memory0 = null;

function getBigInt64Memory0() {
    if (cachedBigInt64Memory0 === null || cachedBigInt64Memory0.byteLength === 0) {
        cachedBigInt64Memory0 = new BigInt64Array(wasm.memory.buffer);
    }
    return cachedBigInt64Memory0;
}

let cachedInt32Memory0 = null;

function getInt32Memory0() {
    if (cachedInt32Memory0 === null || cachedInt32Memory0.byteLength === 0) {
        cachedInt32Memory0 = new Int32Array(wasm.memory.buffer);
    }
    return cachedInt32Memory0;
}

let cachedFloat64Memory0 = null;

function getFloat64Memory0() {
    if (cachedFloat64Memory0 === null || cachedFloat64Memory0.byteLength === 0) {
        cachedFloat64Memory0 = new Float64Array(wasm.memory.buffer);
    }
    return cachedFloat64Memory0;
}

const cachedTextDecoder = (typeof TextDecoder !== 'undefined' ? new TextDecoder('utf-8', { ignoreBOM: true, fatal: true }) : { decode: () => { throw Error('TextDecoder not available') } } );

if (typeof TextDecoder !== 'undefined') { cachedTextDecoder.decode(); };

let cachedUint8Memory0 = null;

function getUint8Memory0() {
    if (cachedUint8Memory0 === null || cachedUint8Memory0.byteLength === 0) {
        cachedUint8Memory0 = new Uint8Array(wasm.memory.buffer);
    }
    return cachedUint8Memory0;
}

function getStringFromWasm0(ptr, len) {
    ptr = ptr >>> 0;
    return cachedTextDecoder.decode(getUint8Memory0().subarray(ptr, ptr + len));
}

let WASM_VECTOR_LEN = 0;

const cachedTextEncoder = (typeof TextEncoder !== 'undefined' ? new TextEncoder('utf-8') : { encode: () => { throw Error('TextEncoder not available') } } );

const encodeString = (typeof cachedTextEncoder.encodeInto === 'function'
    ? function (arg, view) {
    return cachedTextEncoder.encodeInto(arg, view);
}
    : function (arg, view) {
    const buf = cachedTextEncoder.encode(arg);
    view.set(buf);
    return {
        read: arg.length,
        written: buf.length
    };
});

function passStringToWasm0(arg, malloc, realloc) {

    if (realloc === undefined) {
        const buf = cachedTextEncoder.encode(arg);
        const ptr = malloc(buf.length, 1) >>> 0;
        getUint8Memory0().subarray(ptr, ptr + buf.length).set(buf);
        WASM_VECTOR_LEN = buf.length;
        return ptr;
    }

    let len = arg.length;
    let ptr = malloc(len, 1) >>> 0;

    const mem = getUint8Memory0();

    let offset = 0;

    for (; offset < len; offset++) {
        const code = arg.charCodeAt(offset);
        if (code > 0x7F) break;
        mem[ptr + offset] = code;
    }

    if (offset !== len) {
        if (offset !== 0) {
            arg = arg.slice(offset);
        }
        ptr = realloc(ptr, len, len = offset + arg.length * 3, 1) >>> 0;
        const view = getUint8Memory0().subarray(ptr + offset, ptr + len);
        const ret = encodeString(arg, view);

        offset += ret.written;
    }

    WASM_VECTOR_LEN = offset;
    return ptr;
}

function debugString(val) {
    // primitive types
    const type = typeof val;
    if (type == 'number' || type == 'boolean' || val == null) {
        return  `${val}`;
    }
    if (type == 'string') {
        return `"${val}"`;
    }
    if (type == 'symbol') {
        const description = val.description;
        if (description == null) {
            return 'Symbol';
        } else {
            return `Symbol(${description})`;
        }
    }
    if (type == 'function') {
        const name = val.name;
        if (typeof name == 'string' && name.length > 0) {
            return `Function(${name})`;
        } else {
            return 'Function';
        }
    }
    // objects
    if (Array.isArray(val)) {
        const length = val.length;
        let debug = '[';
        if (length > 0) {
            debug += debugString(val[0]);
        }
        for(let i = 1; i < length; i++) {
            debug += ', ' + debugString(val[i]);
        }
        debug += ']';
        return debug;
    }
    // Test for built-in
    const builtInMatches = /\[object ([^\]]+)\]/.exec(toString.call(val));
    let className;
    if (builtInMatches.length > 1) {
        className = builtInMatches[1];
    } else {
        // Failed to match the standard '[object ClassName]'
        return toString.call(val);
    }
    if (className == 'Object') {
        // we're a user defined class or Object
        // JSON.stringify avoids problems with cycles, and is generally much
        // easier than looping through ownProperties of `val`.
        try {
            return 'Object(' + JSON.stringify(val) + ')';
        } catch (_) {
            return 'Object';
        }
    }
    // errors
    if (val instanceof Error) {
        return `${val.name}: ${val.message}\n${val.stack}`;
    }
    // TODO we could test for more things here, like `Set`s and `Map`s.
    return className;
}
/**
*/
export function initialize() {
    wasm.initialize();
}

/**
* @returns {any}
*/
export function layouts() {
    try {
        const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
        wasm.layouts(retptr);
        var r0 = getInt32Memory0()[retptr / 4 + 0];
        var r1 = getInt32Memory0()[retptr / 4 + 1];
        var r2 = getInt32Memory0()[retptr / 4 + 2];
        if (r2) {
            throw takeObject(r1);
        }
        return takeObject(r0);
    } finally {
        wasm.__wbindgen_add_to_stack_pointer(16);
    }
}

let cachedUint32Memory0 = null;

function getUint32Memory0() {
    if (cachedUint32Memory0 === null || cachedUint32Memory0.byteLength === 0) {
        cachedUint32Memory0 = new Uint32Array(wasm.memory.buffer);
    }
    return cachedUint32Memory0;
}

function getArrayU32FromWasm0(ptr, len) {
    ptr = ptr >>> 0;
    return getUint32Memory0().subarray(ptr / 4, ptr / 4 + len);
}

function _assertClass(instance, klass) {
    if (!(instance instanceof klass)) {
        throw new Error(`expected instance of ${klass.name}`);
    }
    return instance.ptr;
}

function getArrayU8FromWasm0(ptr, len) {
    ptr = ptr >>> 0;
    return getUint8Memory0().subarray(ptr / 1, ptr / 1 + len);
}

function getArrayJsValueFromWasm0(ptr, len) {
    ptr = ptr >>> 0;
    const mem = getUint32Memory0();
    const slice = mem.subarray(ptr / 4, ptr / 4 + len);
    const result = [];
    for (let i = 0; i < slice.length; i++) {
        result.push(takeObject(slice[i]));
    }
    return result;
}

function passArray32ToWasm0(arg, malloc) {
    const ptr = malloc(arg.length * 4, 4) >>> 0;
    getUint32Memory0().set(arg, ptr / 4);
    WASM_VECTOR_LEN = arg.length;
    return ptr;
}

function handleError(f, args) {
    try {
        return f.apply(this, args);
    } catch (e) {
        wasm.__wbindgen_exn_store(addHeapObject(e));
    }
}
/**
* A block under construction.
*/
export class Block {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(Block.prototype);
        obj.__wbg_ptr = ptr;

        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;

        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_block_free(ptr);
    }
    /**
    * Start building a block.
    */
    constructor() {
        const ret = wasm.block_new();
        return Block.__wrap(ret);
    }
    /**
    * Add an instruction getting the element of `arr` at index `idx`, and return its variable ID.
    *
    * Assumes `arr` and `idx` are valid variable IDs, that `idx` matches up with `arr`'s `index`
    * type, and that `arr`'s `elem` type is `t`.
    * @param {FuncBuilder} f
    * @param {number} t
    * @param {number} arr
    * @param {number} idx
    * @returns {number}
    */
    index(f, t, arr, idx) {
        _assertClass(f, FuncBuilder);
        const ret = wasm.block_index(this.__wbg_ptr, f.__wbg_ptr, t, arr, idx);
        return ret >>> 0;
    }
    /**
    * Add an instruction getting member `mem` of `x`, and return its variable ID.
    *
    * Assumes `x` is a valid variable ID, that `mem` is a valid member ID for `x`'s struct type,
    * and that the type of that member is `t`.
    * @param {FuncBuilder} f
    * @param {number} t
    * @param {number} x
    * @param {number} mem
    * @returns {number}
    */
    member(f, t, x, mem) {
        _assertClass(f, FuncBuilder);
        const ret = wasm.block_member(this.__wbg_ptr, f.__wbg_ptr, t, x, mem);
        return ret >>> 0;
    }
    /**
    * Return the variable ID for a new boolean negation instruction on `arg`.
    *
    * Assumes `arg` is defined, in scope, and has boolean type.
    * @param {FuncBuilder} f
    * @param {number} arg
    * @returns {number}
    */
    not(f, arg) {
        _assertClass(f, FuncBuilder);
        const ret = wasm.block_not(this.__wbg_ptr, f.__wbg_ptr, arg);
        return ret >>> 0;
    }
    /**
    * Return the variable ID for a new index modulus instruction on `arg`.
    *
    * Assumes `arg` is defined, in scope, and has boolean type.
    * @param {FuncBuilder} f
    * @param {number} t
    * @param {number} arg
    * @returns {number}
    */
    imod(f, t, arg) {
        _assertClass(f, FuncBuilder);
        const ret = wasm.block_imod(this.__wbg_ptr, f.__wbg_ptr, t, arg);
        return ret >>> 0;
    }
    /**
    * Return the variable ID for a new absolute value instruction on `arg`.
    *
    * Assumes `arg` is defined, in scope, and has 64-bit floating point type.
    * @param {FuncBuilder} f
    * @param {number} arg
    * @returns {number}
    */
    abs(f, arg) {
        _assertClass(f, FuncBuilder);
        const ret = wasm.block_abs(this.__wbg_ptr, f.__wbg_ptr, arg);
        return ret >>> 0;
    }
    /**
    * Return the variable ID for a new signum instruction on `arg`.
    *
    * Assumes `arg` is defined, in scope, and has 64-bit floating point type.
    * @param {FuncBuilder} f
    * @param {number} arg
    * @returns {number}
    */
    sign(f, arg) {
        _assertClass(f, FuncBuilder);
        const ret = wasm.block_sign(this.__wbg_ptr, f.__wbg_ptr, arg);
        return ret >>> 0;
    }
    /**
    * Return the variable ID for a new ceiling instruction on `arg`.
    *
    * Assumes `arg` is defined, in scope, and has 64-bit floating point type.
    * @param {FuncBuilder} f
    * @param {number} arg
    * @returns {number}
    */
    ceil(f, arg) {
        _assertClass(f, FuncBuilder);
        const ret = wasm.block_ceil(this.__wbg_ptr, f.__wbg_ptr, arg);
        return ret >>> 0;
    }
    /**
    * Return the variable ID for a new floor instruction on `arg`.
    *
    * Assumes `arg` is defined, in scope, and has 64-bit floating point type.
    * @param {FuncBuilder} f
    * @param {number} arg
    * @returns {number}
    */
    floor(f, arg) {
        _assertClass(f, FuncBuilder);
        const ret = wasm.block_floor(this.__wbg_ptr, f.__wbg_ptr, arg);
        return ret >>> 0;
    }
    /**
    * Return the variable ID for a new truncate instruction on `arg`.
    *
    * Assumes `arg` is defined, in scope, and has 64-bit floating point type.
    * @param {FuncBuilder} f
    * @param {number} arg
    * @returns {number}
    */
    trunc(f, arg) {
        _assertClass(f, FuncBuilder);
        const ret = wasm.block_trunc(this.__wbg_ptr, f.__wbg_ptr, arg);
        return ret >>> 0;
    }
    /**
    * Return the variable ID for a new square root instruction on `arg`.
    *
    * Assumes `arg` is defined, in scope, and has 64-bit floating point type.
    * @param {FuncBuilder} f
    * @param {number} arg
    * @returns {number}
    */
    sqrt(f, arg) {
        _assertClass(f, FuncBuilder);
        const ret = wasm.block_sqrt(this.__wbg_ptr, f.__wbg_ptr, arg);
        return ret >>> 0;
    }
    /**
    * Return the variable ID for a new logical conjunction instruction on `left` and `right`.
    *
    * Assumes `left` and `right` are defined, in scope, and have boolean type.
    * @param {FuncBuilder} f
    * @param {number} left
    * @param {number} right
    * @returns {number}
    */
    and(f, left, right) {
        _assertClass(f, FuncBuilder);
        const ret = wasm.block_and(this.__wbg_ptr, f.__wbg_ptr, left, right);
        return ret >>> 0;
    }
    /**
    * Return the variable ID for a new logical disjunction instruction on `left` and `right`.
    *
    * Assumes `left` and `right` are defined, in scope, and have boolean type.
    * @param {FuncBuilder} f
    * @param {number} left
    * @param {number} right
    * @returns {number}
    */
    or(f, left, right) {
        _assertClass(f, FuncBuilder);
        const ret = wasm.block_or(this.__wbg_ptr, f.__wbg_ptr, left, right);
        return ret >>> 0;
    }
    /**
    * Return the variable ID for a new boolean equality instruction on `left` and `right`.
    *
    * Assumes `left` and `right` are defined, in scope, and have boolean type.
    * @param {FuncBuilder} f
    * @param {number} left
    * @param {number} right
    * @returns {number}
    */
    iff(f, left, right) {
        _assertClass(f, FuncBuilder);
        const ret = wasm.block_iff(this.__wbg_ptr, f.__wbg_ptr, left, right);
        return ret >>> 0;
    }
    /**
    * Return the variable ID for a new exclusive disjunction instruction on `left` and `right`.
    *
    * Assumes `left` and `right` are defined, in scope, and have boolean type.
    * @param {FuncBuilder} f
    * @param {number} left
    * @param {number} right
    * @returns {number}
    */
    xor(f, left, right) {
        _assertClass(f, FuncBuilder);
        const ret = wasm.block_xor(this.__wbg_ptr, f.__wbg_ptr, left, right);
        return ret >>> 0;
    }
    /**
    * Return the variable ID for a new "index not equal" instruction on `left` and `right`.
    *
    * Assumes `left` and `right` are defined, in scope, and have the same `Fin` type.
    * @param {FuncBuilder} f
    * @param {number} left
    * @param {number} right
    * @returns {number}
    */
    ineq(f, left, right) {
        _assertClass(f, FuncBuilder);
        const ret = wasm.block_ineq(this.__wbg_ptr, f.__wbg_ptr, left, right);
        return ret >>> 0;
    }
    /**
    * Return the variable ID for a new "index less than" instruction on `left` and `right`.
    *
    * Assumes `left` and `right` are defined, in scope, and have the same `Fin` type.
    * @param {FuncBuilder} f
    * @param {number} left
    * @param {number} right
    * @returns {number}
    */
    ilt(f, left, right) {
        _assertClass(f, FuncBuilder);
        const ret = wasm.block_ilt(this.__wbg_ptr, f.__wbg_ptr, left, right);
        return ret >>> 0;
    }
    /**
    * Return the variable ID for a new "index less than or equal" instruction on `left` and
    * `right`.
    *
    * Assumes `left` and `right` are defined, in scope, and have the same `Fin` type.
    * @param {FuncBuilder} f
    * @param {number} left
    * @param {number} right
    * @returns {number}
    */
    ileq(f, left, right) {
        _assertClass(f, FuncBuilder);
        const ret = wasm.block_ileq(this.__wbg_ptr, f.__wbg_ptr, left, right);
        return ret >>> 0;
    }
    /**
    * Return the variable ID for a new "index equal" instruction on `left` and `right`.
    *
    * Assumes `left` and `right` are defined, in scope, and have the same `Fin` type.
    * @param {FuncBuilder} f
    * @param {number} left
    * @param {number} right
    * @returns {number}
    */
    ieq(f, left, right) {
        _assertClass(f, FuncBuilder);
        const ret = wasm.block_ieq(this.__wbg_ptr, f.__wbg_ptr, left, right);
        return ret >>> 0;
    }
    /**
    * Return the variable ID for a new "index greater than" instruction on `left` and `right`.
    *
    * Assumes `left` and `right` are defined, in scope, and have the same `Fin` type.
    * @param {FuncBuilder} f
    * @param {number} left
    * @param {number} right
    * @returns {number}
    */
    igt(f, left, right) {
        _assertClass(f, FuncBuilder);
        const ret = wasm.block_igt(this.__wbg_ptr, f.__wbg_ptr, left, right);
        return ret >>> 0;
    }
    /**
    * Return the variable ID for a new "index greater than or equal" instruction on `left` and
    * `right`.
    *
    * Assumes `left` and `right` are defined, in scope, and have the same `Fin` type.
    * @param {FuncBuilder} f
    * @param {number} left
    * @param {number} right
    * @returns {number}
    */
    igeq(f, left, right) {
        _assertClass(f, FuncBuilder);
        const ret = wasm.block_igeq(this.__wbg_ptr, f.__wbg_ptr, left, right);
        return ret >>> 0;
    }
    /**
    * Return the variable ID for a new "index add" instruction on `left` and `right`.
    *
    * Assumes `left` and `right` are defined, in scope, and have the same `Fin` type.
    * @param {FuncBuilder} f
    * @param {number} t
    * @param {number} left
    * @param {number} right
    * @returns {number}
    */
    iadd(f, t, left, right) {
        _assertClass(f, FuncBuilder);
        const ret = wasm.block_iadd(this.__wbg_ptr, f.__wbg_ptr, t, left, right);
        return ret >>> 0;
    }
    /**
    * Return the variable ID for a new "not equal" instruction on `left` and `right`.
    *
    * Assumes `left` and `right` are defined, in scope, and have 64-bit floating point type.
    * @param {FuncBuilder} f
    * @param {number} left
    * @param {number} right
    * @returns {number}
    */
    neq(f, left, right) {
        _assertClass(f, FuncBuilder);
        const ret = wasm.block_neq(this.__wbg_ptr, f.__wbg_ptr, left, right);
        return ret >>> 0;
    }
    /**
    * Return the variable ID for a new "less than" instruction on `left` and `right`.
    *
    * Assumes `left` and `right` are defined, in scope, and have 64-bit floating point type.
    * @param {FuncBuilder} f
    * @param {number} left
    * @param {number} right
    * @returns {number}
    */
    lt(f, left, right) {
        _assertClass(f, FuncBuilder);
        const ret = wasm.block_lt(this.__wbg_ptr, f.__wbg_ptr, left, right);
        return ret >>> 0;
    }
    /**
    * Return the variable ID for a new "less than or equal" instruction on `left` and `right`.
    *
    * Assumes `left` and `right` are defined, in scope, and have 64-bit floating point type.
    * @param {FuncBuilder} f
    * @param {number} left
    * @param {number} right
    * @returns {number}
    */
    leq(f, left, right) {
        _assertClass(f, FuncBuilder);
        const ret = wasm.block_leq(this.__wbg_ptr, f.__wbg_ptr, left, right);
        return ret >>> 0;
    }
    /**
    * Return the variable ID for a new "equal" instruction on `left` and `right`.
    *
    * Assumes `left` and `right` are defined, in scope, and have 64-bit floating point type.
    * @param {FuncBuilder} f
    * @param {number} left
    * @param {number} right
    * @returns {number}
    */
    eq(f, left, right) {
        _assertClass(f, FuncBuilder);
        const ret = wasm.block_eq(this.__wbg_ptr, f.__wbg_ptr, left, right);
        return ret >>> 0;
    }
    /**
    * Return the variable ID for a new "greater than" instruction on `left` and `right`.
    *
    * Assumes `left` and `right` are defined, in scope, and have 64-bit floating point type.
    * @param {FuncBuilder} f
    * @param {number} left
    * @param {number} right
    * @returns {number}
    */
    gt(f, left, right) {
        _assertClass(f, FuncBuilder);
        const ret = wasm.block_gt(this.__wbg_ptr, f.__wbg_ptr, left, right);
        return ret >>> 0;
    }
    /**
    * Return the variable ID for a new "greater than or equal" instruction on `left` and `right`.
    *
    * Assumes `left` and `right` are defined, in scope, and have 64-bit floating point type.
    * @param {FuncBuilder} f
    * @param {number} left
    * @param {number} right
    * @returns {number}
    */
    geq(f, left, right) {
        _assertClass(f, FuncBuilder);
        const ret = wasm.block_geq(this.__wbg_ptr, f.__wbg_ptr, left, right);
        return ret >>> 0;
    }
    /**
    * Return the variable ID for a new instruction using `cond` to choose `then` or `els`.
    *
    * Assumes `cond`, `then`, and `els` are defined and in scope, that `cond` has boolean type,
    * and that `then` and `els` both have type `t`.
    * @param {FuncBuilder} f
    * @param {number} cond
    * @param {number} t
    * @param {number} then
    * @param {number} els
    * @returns {number}
    */
    select(f, cond, t, then, els) {
        _assertClass(f, FuncBuilder);
        const ret = wasm.block_select(this.__wbg_ptr, f.__wbg_ptr, cond, t, then, els);
        return ret >>> 0;
    }
    /**
    * Return the variable ID for a new instruction calling `g` with `generics` and `args`.
    *
    * Assumes that `generics` are all valid type IDs, and have the right length and constraints;
    * that `args` are all valid variable IDs and match up with `g`'s parameter types; and that the
    * return type of `g` matches `t` (all in the context of the given `generics`).
    * @param {FuncBuilder} f
    * @param {Func} g
    * @param {Uint32Array} generics
    * @param {number} t
    * @param {Uint32Array} args
    * @returns {number}
    */
    call(f, g, generics, t, args) {
        _assertClass(f, FuncBuilder);
        _assertClass(g, Func);
        const ptr0 = passArray32ToWasm0(generics, wasm.__wbindgen_malloc);
        const len0 = WASM_VECTOR_LEN;
        const ptr1 = passArray32ToWasm0(args, wasm.__wbindgen_malloc);
        const len1 = WASM_VECTOR_LEN;
        const ret = wasm.block_call(this.__wbg_ptr, f.__wbg_ptr, g.__wbg_ptr, ptr0, len0, t, ptr1, len1);
        return ret >>> 0;
    }
    /**
    * Return the variable ID for a new instruction defining an array elementwise via `body`.
    *
    * Assumes `arg` is defined and in scope; this represents the index variable for the element
    * definition body, so its dependencies are prepended to the body code and it is marked as
    * expired. Also assumes `out` is defined by `body`; this represents the final variable
    * defining each array element. Finally, assumes the type of the array (not the element)
    * matches `t`.
    * @param {FuncBuilder} f
    * @param {number} t
    * @param {number} arg
    * @param {Block} body
    * @param {number} out
    * @returns {number}
    */
    vec(f, t, arg, body, out) {
        _assertClass(f, FuncBuilder);
        _assertClass(body, Block);
        var ptr0 = body.__destroy_into_raw();
        const ret = wasm.block_vec(this.__wbg_ptr, f.__wbg_ptr, t, arg, ptr0, out);
        return ret >>> 0;
    }
    /**
    * Return the variable ID for a new instruction defining an accumulator with the given `shape`.
    *
    * Assumes `shape` is defined and in scope, and that `t` is the ID of a reference type whose
    * inner type is the same as the type of `shape`.
    * @param {FuncBuilder} f
    * @param {number} t
    * @param {number} shape
    * @returns {number}
    */
    accum(f, t, shape) {
        _assertClass(f, FuncBuilder);
        const ret = wasm.block_accum(this.__wbg_ptr, f.__wbg_ptr, t, shape);
        return ret >>> 0;
    }
    /**
    * Return the variable ID for a new instruction accumulating `addend` into `accum`.
    *
    * Assumes `accum` and `addend` are defined and in scope.
    * @param {FuncBuilder} f
    * @param {number} accum
    * @param {number} addend
    * @returns {number}
    */
    addTo(f, accum, addend) {
        _assertClass(f, FuncBuilder);
        const ret = wasm.block_addTo(this.__wbg_ptr, f.__wbg_ptr, accum, addend);
        return ret >>> 0;
    }
    /**
    * Return the variable ID for a new instruction resolving the given accumulator `var`.
    *
    * Assumes `var` is defined and in scope, and that `t` is the inner type of the reference type
    * for `var`.
    * @param {FuncBuilder} f
    * @param {number} t
    * @param {number} _var
    * @returns {number}
    */
    resolve(f, t, _var) {
        _assertClass(f, FuncBuilder);
        const ret = wasm.block_resolve(this.__wbg_ptr, f.__wbg_ptr, t, _var);
        return ret >>> 0;
    }
    /**
    * Return the variable ID for a new floating-point negation instruction on `arg`.
    *
    * `Err` if `arg` is undefined or out of scope, or if its type is not `F64` or `T64`.
    * @param {FuncBuilder} f
    * @param {number} arg
    * @returns {number}
    */
    neg(f, arg) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            _assertClass(f, FuncBuilder);
            wasm.block_neg(retptr, this.__wbg_ptr, f.__wbg_ptr, arg);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            var r2 = getInt32Memory0()[retptr / 4 + 2];
            if (r2) {
                throw takeObject(r1);
            }
            return r0 >>> 0;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * Return the variable ID for a new addition instruction on `left` and `right`.
    *
    * `Err` if `left` or `right` is undefined or out of scope, or if their types are not either
    * both `F64` or both `T64`.
    * @param {FuncBuilder} f
    * @param {number} left
    * @param {number} right
    * @returns {number}
    */
    add(f, left, right) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            _assertClass(f, FuncBuilder);
            wasm.block_add(retptr, this.__wbg_ptr, f.__wbg_ptr, left, right);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            var r2 = getInt32Memory0()[retptr / 4 + 2];
            if (r2) {
                throw takeObject(r1);
            }
            return r0 >>> 0;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * Return the variable ID for a new subtraction instruction on `left` and `right`.
    *
    * `Err` if `left` or `right` is undefined or out of scope, or if their types are not either
    * both `F64` or both `T64`.
    * @param {FuncBuilder} f
    * @param {number} left
    * @param {number} right
    * @returns {number}
    */
    sub(f, left, right) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            _assertClass(f, FuncBuilder);
            wasm.block_sub(retptr, this.__wbg_ptr, f.__wbg_ptr, left, right);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            var r2 = getInt32Memory0()[retptr / 4 + 2];
            if (r2) {
                throw takeObject(r1);
            }
            return r0 >>> 0;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * Return the variable ID for a new multiplication instruction on `left` and `right`.
    *
    * `Err` if `left` or `right` is undefined or out of scope, or if `left`'s type is not `F64` or
    * `T64`, or if `right`'s type is not `F64`.
    * @param {FuncBuilder} f
    * @param {number} left
    * @param {number} right
    * @returns {number}
    */
    mul(f, left, right) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            _assertClass(f, FuncBuilder);
            wasm.block_mul(retptr, this.__wbg_ptr, f.__wbg_ptr, left, right);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            var r2 = getInt32Memory0()[retptr / 4 + 2];
            if (r2) {
                throw takeObject(r1);
            }
            return r0 >>> 0;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * Return the variable ID for a new division instruction on `left` and `right`.
    *
    * `Err` if `left` or `right` is undefined or out of scope, or if `left`'s type is not `F64` or
    * `T64`, or if `right`'s type is not `F64`.
    * @param {FuncBuilder} f
    * @param {number} left
    * @param {number} right
    * @returns {number}
    */
    div(f, left, right) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            _assertClass(f, FuncBuilder);
            wasm.block_div(retptr, this.__wbg_ptr, f.__wbg_ptr, left, right);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            var r2 = getInt32Memory0()[retptr / 4 + 2];
            if (r2) {
                throw takeObject(r1);
            }
            return r0 >>> 0;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
}
/**
* A node in a reference-counted acyclic digraph of functions.
*/
export class Func {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(Func.prototype);
        obj.__wbg_ptr = ptr;

        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;

        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_func_free(ptr);
    }
    /**
    * Return an opaque function taking `params` `F64` parameters and returning `F64`.
    * @param {number} params
    * @param {Function} def
    */
    constructor(params, def) {
        const ret = wasm.func_new(params, addHeapObject(def));
        return Func.__wrap(ret);
    }
    /**
    * @returns {string}
    */
    pprint() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.func_pprint(retptr, this.__wbg_ptr);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    * Return the IDs of this function's parameter types.
    * @returns {Uint32Array}
    */
    paramTypes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.func_paramTypes(retptr, this.__wbg_ptr);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            var v1 = getArrayU32FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 4);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * Return the ID of this function's return type.
    * @returns {number}
    */
    retType() {
        const ret = wasm.func_retType(this.__wbg_ptr);
        return ret >>> 0;
    }
    /**
    * Return the number of types defined in this function.
    * @returns {number}
    */
    numTypes() {
        const ret = wasm.func_numTypes(this.__wbg_ptr);
        return ret >>> 0;
    }
    /**
    * Return true iff `t` is the ID of a unit type.
    * @param {number} t
    * @returns {boolean}
    */
    isUnit(t) {
        const ret = wasm.func_isUnit(this.__wbg_ptr, t);
        return ret !== 0;
    }
    /**
    * Return true iff `t` is the ID of a boolean type.
    * @param {number} t
    * @returns {boolean}
    */
    isBool(t) {
        const ret = wasm.func_isBool(this.__wbg_ptr, t);
        return ret !== 0;
    }
    /**
    * Return true iff `t` is the ID of a 64-bit floating-point type.
    * @param {number} t
    * @returns {boolean}
    */
    isF64(t) {
        const ret = wasm.func_isF64(this.__wbg_ptr, t);
        return ret !== 0;
    }
    /**
    * Return true iff `t` is the ID of a finite integer type.
    * @param {number} t
    * @returns {boolean}
    */
    isFin(t) {
        const ret = wasm.func_isFin(this.__wbg_ptr, t);
        return ret !== 0;
    }
    /**
    * Return true iff `t` is the ID of an array type.
    * @param {number} t
    * @returns {boolean}
    */
    isArray(t) {
        const ret = wasm.func_isArray(this.__wbg_ptr, t);
        return ret !== 0;
    }
    /**
    * Return true iff `t` is the ID of a struct type.
    * @param {number} t
    * @returns {boolean}
    */
    isStruct(t) {
        const ret = wasm.func_isStruct(this.__wbg_ptr, t);
        return ret !== 0;
    }
    /**
    * Return the size of the finite integer type with ID `t`.
    * @param {number} t
    * @returns {number}
    */
    size(t) {
        const ret = wasm.func_size(this.__wbg_ptr, t);
        return ret >>> 0;
    }
    /**
    * Return the ID of the index type for the array type with ID `t`.
    * @param {number} t
    * @returns {number}
    */
    index(t) {
        const ret = wasm.func_index(this.__wbg_ptr, t);
        return ret >>> 0;
    }
    /**
    * Return the ID of the element type for the array type with ID `t`.
    * @param {number} t
    * @returns {number}
    */
    elem(t) {
        const ret = wasm.func_elem(this.__wbg_ptr, t);
        return ret >>> 0;
    }
    /**
    * Return the string IDs for the struct type with ID `t`.
    * @param {number} t
    * @returns {Uint32Array}
    */
    keys(t) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.func_keys(retptr, this.__wbg_ptr, t);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            var v1 = getArrayU32FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 4);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * Return the member type IDs for the struct type with ID `t`.
    * @param {number} t
    * @returns {Uint32Array}
    */
    mems(t) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.func_mems(retptr, this.__wbg_ptr, t);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            var v1 = getArrayU32FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 4);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * Interpret a function with no generics or parameters.
    *
    * The `args` are Serde-converted to `Vec<rose_interp::Val>`, and the return value is
    * Serde-converted from `rose_interp::Val`.
    * @param {any} args
    * @returns {any}
    */
    interp(args) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.func_interp(retptr, this.__wbg_ptr, addHeapObject(args));
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            var r2 = getInt32Memory0()[retptr / 4 + 2];
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * Compile the call graph subtended by this function to WebAssembly.
    * @returns {Wasm}
    */
    compile() {
        const ret = wasm.func_compile(this.__wbg_ptr);
        return Wasm.__wrap(ret);
    }
    /**
    * Set the JVP of this function to `f`.
    * @param {Func} f
    */
    setJvp(f) {
        _assertClass(f, Func);
        wasm.func_setJvp(this.__wbg_ptr, f.__wbg_ptr);
    }
    /**
    * Return a function that computes the Jacobian-vector product of this function.
    *
    * `re` must be the string ID for the string `"re"` not just in this function, but in every
    * function that this function calls, and so on, transitively. Same for `du` and `"du"`.
    * @param {number} re
    * @param {number} du
    * @returns {Func}
    */
    jvp(re, du) {
        const ret = wasm.func_jvp(this.__wbg_ptr, re, du);
        return Func.__wrap(ret);
    }
    /**
    * Return the transpose of this function.
    *
    * Assumes that this function has already been computed as the `jvp` of another function.
    * @returns {Transpose}
    */
    transpose() {
        const ret = wasm.func_transpose(this.__wbg_ptr);
        return Transpose.__wrap(ret);
    }
}
/**
* A function under construction.
*/
export class FuncBuilder {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(FuncBuilder.prototype);
        obj.__wbg_ptr = ptr;

        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;

        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_funcbuilder_free(ptr);
    }
    /**
    * Start building a function with the given number of `generics`, all constrained as `Index`.
    * @param {number} generics
    */
    constructor(generics) {
        const ret = wasm.funcbuilder_new(generics);
        return FuncBuilder.__wrap(ret);
    }
    /**
    * Assemble this function with return variable `out` and the given `body`.
    * @param {number} out
    * @param {Block} body
    * @returns {Func}
    */
    finish(out, body) {
        const ptr = this.__destroy_into_raw();
        _assertClass(body, Block);
        var ptr0 = body.__destroy_into_raw();
        const ret = wasm.funcbuilder_finish(ptr, out, ptr0);
        return Func.__wrap(ret);
    }
    /**
    * Should the type with ID `t` be represented as a JavaScript `Symbol`?
    *
    * Values of index types must be symbols so that we can use the standard JavaScript indexing
    * notation (along with `Proxy`, see below) to generate array accessing code.
    * @param {number} t
    * @returns {boolean}
    */
    isSymbol(t) {
        const ret = wasm.funcbuilder_isSymbol(this.__wbg_ptr, t);
        return ret !== 0;
    }
    /**
    * Is the type with ID `t` an array that should be represented as a JavaScript `Proxy`?
    *
    * Values of array types must be proxies so that we can use the standard JavaScript indexing
    * notation (along with `Symbol`, see above) to generate array accessing code.
    * @param {number} t
    * @returns {boolean}
    */
    isArray(t) {
        const ret = wasm.funcbuilder_isArray(this.__wbg_ptr, t);
        return ret !== 0;
    }
    /**
    * Is the type with ID `t` a struct that should be represented as a JavaScript `Proxy`?
    *
    * Values of struct types must be proxies so that we can use the standard JavaScript property
    * access notation to generate member accessing code.
    * @param {number} t
    * @returns {boolean}
    */
    isStruct(t) {
        const ret = wasm.funcbuilder_isStruct(this.__wbg_ptr, t);
        return ret !== 0;
    }
    /**
    * Return the ID of the index type for the array type with ID `t`.
    *
    * `Err` if `t` is out of range or does not represent an array type.
    * @param {number} t
    * @returns {number}
    */
    index(t) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.funcbuilder_index(retptr, this.__wbg_ptr, t);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            var r2 = getInt32Memory0()[retptr / 4 + 2];
            if (r2) {
                throw takeObject(r1);
            }
            return r0 >>> 0;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * Return the number of elements for the array type with ID `t`.
    *
    * `Err` if `t` is out of range or does not represent an array type, or if its index type is
    * not a fixed size (e.g. if it is a generic type parameter of the function).
    * @param {number} t
    * @returns {number}
    */
    size(t) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.funcbuilder_size(retptr, this.__wbg_ptr, t);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            var r2 = getInt32Memory0()[retptr / 4 + 2];
            if (r2) {
                throw takeObject(r1);
            }
            return r0 >>> 0;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * Return the ID of the element type for the array type with ID `t`.
    *
    * `Err` if `t` is out of range or does not represent an array type.
    * @param {number} t
    * @returns {number}
    */
    elem(t) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.funcbuilder_elem(retptr, this.__wbg_ptr, t);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            var r2 = getInt32Memory0()[retptr / 4 + 2];
            if (r2) {
                throw takeObject(r1);
            }
            return r0 >>> 0;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * Return the string IDs of the keys for the struct type with ID `t`.
    *
    * `Err` if `t` is out of range or does not represent a struct type.
    * @param {number} t
    * @returns {Uint32Array}
    */
    keys(t) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.funcbuilder_keys(retptr, this.__wbg_ptr, t);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            var r2 = getInt32Memory0()[retptr / 4 + 2];
            var r3 = getInt32Memory0()[retptr / 4 + 3];
            if (r3) {
                throw takeObject(r2);
            }
            var v1 = getArrayU32FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 4);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * Return the type IDs of the members for the struct type with ID `t`.
    *
    * `Err` if `t` is out of range or does not represent a struct type.
    * @param {number} t
    * @returns {Uint32Array}
    */
    members(t) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.funcbuilder_members(retptr, this.__wbg_ptr, t);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            var r2 = getInt32Memory0()[retptr / 4 + 2];
            var r3 = getInt32Memory0()[retptr / 4 + 3];
            if (r3) {
                throw takeObject(r2);
            }
            var v1 = getArrayU32FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 4);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * Return `x` if it exists, is in scope, and has type ID `t`; `Err` otherwise.
    * @param {number} t
    * @param {number} x
    * @returns {number}
    */
    expect(t, x) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.funcbuilder_expect(retptr, this.__wbg_ptr, t, x);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            var r2 = getInt32Memory0()[retptr / 4 + 2];
            if (r2) {
                throw takeObject(r1);
            }
            return r0 >>> 0;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * Return the ID for the unit type, creating if needed.
    * @returns {number}
    */
    tyUnit() {
        const ret = wasm.funcbuilder_tyUnit(this.__wbg_ptr);
        return ret >>> 0;
    }
    /**
    * Return the ID for the boolean type, creating if needed.
    * @returns {number}
    */
    tyBool() {
        const ret = wasm.funcbuilder_tyBool(this.__wbg_ptr);
        return ret >>> 0;
    }
    /**
    * Return the ID for the 64-bit floating-point type, creating if needed.
    * @returns {number}
    */
    tyF64() {
        const ret = wasm.funcbuilder_tyF64(this.__wbg_ptr);
        return ret >>> 0;
    }
    /**
    * Return the ID for the 64-bit floating-point tangent type, creating if needed.
    * @returns {number}
    */
    tyT64() {
        const ret = wasm.funcbuilder_tyT64(this.__wbg_ptr);
        return ret >>> 0;
    }
    /**
    * Return the ID for the type of nonnegative integers less than `size`, creating if needed.
    * @param {number} size
    * @returns {number}
    */
    tyFin(size) {
        const ret = wasm.funcbuilder_tyFin(this.__wbg_ptr, size);
        return ret >>> 0;
    }
    /**
    * @param {number} inner
    * @returns {number}
    */
    tyRef(inner) {
        const ret = wasm.funcbuilder_tyRef(this.__wbg_ptr, inner);
        return ret >>> 0;
    }
    /**
    * Return the ID for the type of arrays with index type `index` and element type `elem`,
    *
    * Assumes `index` and `elem` are valid type IDs.
    * @param {number} index
    * @param {number} elem
    * @returns {number}
    */
    tyArray(index, elem) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.funcbuilder_tyArray(retptr, this.__wbg_ptr, index, elem);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            var r2 = getInt32Memory0()[retptr / 4 + 2];
            if (r2) {
                throw takeObject(r1);
            }
            return r0 >>> 0;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * Return the ID fr the type of structs with key string IDs `keys` and member type IDs `mems`.
    *
    * Assumes `keys` are valid string IDs and `mems` are valid type IDs.
    * @param {Uint32Array} keys
    * @param {Uint32Array} mems
    * @returns {number}
    */
    tyStruct(keys, mems) {
        const ptr0 = passArray32ToWasm0(keys, wasm.__wbindgen_malloc);
        const len0 = WASM_VECTOR_LEN;
        const ptr1 = passArray32ToWasm0(mems, wasm.__wbindgen_malloc);
        const len1 = WASM_VECTOR_LEN;
        const ret = wasm.funcbuilder_tyStruct(this.__wbg_ptr, ptr0, len0, ptr1, len1);
        return ret >>> 0;
    }
    /**
    * Return the ID of a new variable with type ID `t`.
    * @param {number} t
    * @returns {number}
    */
    bind(t) {
        const ret = wasm.funcbuilder_bind(this.__wbg_ptr, t);
        return ret >>> 0;
    }
    /**
    * Append a parameter with type ID `t` and return its variable ID.
    * @param {number} t
    * @returns {number}
    */
    param(t) {
        const ret = wasm.funcbuilder_param(this.__wbg_ptr, t);
        return ret >>> 0;
    }
    /**
    * Create a constant variable with the unit type, and return its ID.
    *
    * `Err` if `t` is not the ID of the unit type.
    * @param {number} t
    * @returns {number}
    */
    unit(t) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.funcbuilder_unit(retptr, this.__wbg_ptr, t);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            var r2 = getInt32Memory0()[retptr / 4 + 2];
            if (r2) {
                throw takeObject(r1);
            }
            return r0 >>> 0;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * Create a constant variable with the boolean type and value `val`, and return its ID.
    *
    * `Err` if `t` is not the ID of the boolean type.
    * @param {number} t
    * @param {boolean} val
    * @returns {number}
    */
    bool(t, val) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.funcbuilder_bool(retptr, this.__wbg_ptr, t, val);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            var r2 = getInt32Memory0()[retptr / 4 + 2];
            if (r2) {
                throw takeObject(r1);
            }
            return r0 >>> 0;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * Return the ID of a new numeric constant variable with type `t` and value converted from `x`.
    *
    * `Err` unless `t` is the ID of either the 64-bit floating-point type or a finite nonnegative
    * integer type; or if `t` is an integer type which cannot represent the given value of `x`.
    * @param {number} t
    * @param {number} x
    * @returns {number}
    */
    num(t, x) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.funcbuilder_num(retptr, this.__wbg_ptr, t, x);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            var r2 = getInt32Memory0()[retptr / 4 + 2];
            if (r2) {
                throw takeObject(r1);
            }
            return r0 >>> 0;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * Return the ID of a new array variable with type ID `t` and elements `xs`.
    *
    * Assumes that `t` is a valid type ID and `xs` are all valid variable IDs. If there are no
    * dependencies on parameters then the new array variable is a constant; otherwise, it is
    * attached to whichever parent variable reachable from `xs` has the highest ID.
    * @param {number} t
    * @param {Uint32Array} xs
    * @returns {number}
    */
    array(t, xs) {
        const ptr0 = passArray32ToWasm0(xs, wasm.__wbindgen_malloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.funcbuilder_array(this.__wbg_ptr, t, ptr0, len0);
        return ret >>> 0;
    }
    /**
    * Return the ID of a new struct variable with type ID `t` and elements `xs`.
    *
    * Assumes that `t` is a valid type ID and `xs` are all valid variable IDs. If there are no
    * dependencies on parameters then the new struct variable is a constant; otherwise, it is
    * attached to whichever parent variable reachable from `xs` has the highest ID.
    * @param {number} t
    * @param {Uint32Array} xs
    * @returns {number}
    */
    obj(t, xs) {
        const ptr0 = passArray32ToWasm0(xs, wasm.__wbindgen_malloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.funcbuilder_obj(this.__wbg_ptr, t, ptr0, len0);
        return ret >>> 0;
    }
    /**
    * Return the parameter and return type IDs in this function for calling `f` with `generics`.
    *
    * Assumes `generics` are all valid type IDs, and have the right length and constraints.
    *
    * The returned `Vec` is always nonempty, since its last element is the return type; all the
    * other elements are the parameter types.
    * @param {Func} f
    * @param {Uint32Array} strings
    * @param {Uint32Array} generics
    * @returns {Uint32Array}
    */
    ingest(f, strings, generics) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            _assertClass(f, Func);
            const ptr0 = passArray32ToWasm0(strings, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            const ptr1 = passArray32ToWasm0(generics, wasm.__wbindgen_malloc);
            const len1 = WASM_VECTOR_LEN;
            wasm.funcbuilder_ingest(retptr, this.__wbg_ptr, f.__wbg_ptr, ptr0, len0, ptr1, len1);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            var v3 = getArrayU32FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 4);
            return v3;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
}
/**
* A temporary object to hold the two passes of a transposed function before they are destructured.
*/
export class Transpose {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(Transpose.prototype);
        obj.__wbg_ptr = ptr;

        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;

        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_transpose_free(ptr);
    }
    /**
    * Return the forward pass.
    * @returns {Func | undefined}
    */
    fwd() {
        const ret = wasm.transpose_fwd(this.__wbg_ptr);
        return ret === 0 ? undefined : Func.__wrap(ret);
    }
    /**
    * Return the backward pass.
    * @returns {Func | undefined}
    */
    bwd() {
        const ret = wasm.transpose_bwd(this.__wbg_ptr);
        return ret === 0 ? undefined : Func.__wrap(ret);
    }
}
/**
* A temporary object to hold a generated WebAssembly module and its imports.
*/
export class Wasm {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(Wasm.prototype);
        obj.__wbg_ptr = ptr;

        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;

        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_wasm_free(ptr);
    }
    /**
    * @returns {bigint}
    */
    get pages() {
        const ret = wasm.__wbg_get_wasm_pages(this.__wbg_ptr);
        return BigInt.asUintN(64, ret);
    }
    /**
    * @param {bigint} arg0
    */
    set pages(arg0) {
        wasm.__wbg_set_wasm_pages(this.__wbg_ptr, arg0);
    }
    /**
    * Return the module binary.
    * @returns {Uint8Array | undefined}
    */
    bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.wasm_bytes(retptr, this.__wbg_ptr);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            let v1;
            if (r0 !== 0) {
                v1 = getArrayU8FromWasm0(r0, r1).slice();
                wasm.__wbindgen_free(r0, r1 * 1);
            }
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * Return the imports.
    * @returns {(Function)[] | undefined}
    */
    imports() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.wasm_imports(retptr, this.__wbg_ptr);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            let v1;
            if (r0 !== 0) {
                v1 = getArrayJsValueFromWasm0(r0, r1).slice();
                wasm.__wbindgen_free(r0, r1 * 4);
            }
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
}

async function __wbg_load(module, imports) {
    if (typeof Response === 'function' && module instanceof Response) {
        if (typeof WebAssembly.instantiateStreaming === 'function') {
            try {
                return await WebAssembly.instantiateStreaming(module, imports);

            } catch (e) {
                if (module.headers.get('Content-Type') != 'application/wasm') {
                    console.warn("`WebAssembly.instantiateStreaming` failed because your server does not serve wasm with `application/wasm` MIME type. Falling back to `WebAssembly.instantiate` which is slower. Original error:\n", e);

                } else {
                    throw e;
                }
            }
        }

        const bytes = await module.arrayBuffer();
        return await WebAssembly.instantiate(bytes, imports);

    } else {
        const instance = await WebAssembly.instantiate(module, imports);

        if (instance instanceof WebAssembly.Instance) {
            return { instance, module };

        } else {
            return instance;
        }
    }
}

function __wbg_get_imports() {
    const imports = {};
    imports.wbg = {};
    imports.wbg.__wbg_new_f9876326328f45ed = function() {
        const ret = new Object();
        return addHeapObject(ret);
    };
    imports.wbg.__wbg_set_20cbc34131e76824 = function(arg0, arg1, arg2) {
        getObject(arg0)[takeObject(arg1)] = takeObject(arg2);
    };
    imports.wbg.__wbindgen_number_new = function(arg0) {
        const ret = arg0;
        return addHeapObject(ret);
    };
    imports.wbg.__wbindgen_bigint_from_u64 = function(arg0) {
        const ret = BigInt.asUintN(64, arg0);
        return addHeapObject(ret);
    };
    imports.wbg.__wbg_new_b525de17f44a8943 = function() {
        const ret = new Array();
        return addHeapObject(ret);
    };
    imports.wbg.__wbg_set_17224bc548dd1d7b = function(arg0, arg1, arg2) {
        getObject(arg0)[arg1 >>> 0] = takeObject(arg2);
    };
    imports.wbg.__wbindgen_object_drop_ref = function(arg0) {
        takeObject(arg0);
    };
    imports.wbg.__wbg_next_88560ec06a094dea = function() { return handleError(function (arg0) {
        const ret = getObject(arg0).next();
        return addHeapObject(ret);
    }, arguments) };
    imports.wbg.__wbg_done_1ebec03bbd919843 = function(arg0) {
        const ret = getObject(arg0).done;
        return ret;
    };
    imports.wbg.__wbg_value_6ac8da5cc5b3efda = function(arg0) {
        const ret = getObject(arg0).value;
        return addHeapObject(ret);
    };
    imports.wbg.__wbindgen_jsval_loose_eq = function(arg0, arg1) {
        const ret = getObject(arg0) == getObject(arg1);
        return ret;
    };
    imports.wbg.__wbindgen_is_bigint = function(arg0) {
        const ret = typeof(getObject(arg0)) === 'bigint';
        return ret;
    };
    imports.wbg.__wbindgen_bigint_get_as_i64 = function(arg0, arg1) {
        const v = getObject(arg1);
        const ret = typeof(v) === 'bigint' ? v : undefined;
        getBigInt64Memory0()[arg0 / 8 + 1] = isLikeNone(ret) ? BigInt(0) : ret;
        getInt32Memory0()[arg0 / 4 + 0] = !isLikeNone(ret);
    };
    imports.wbg.__wbindgen_jsval_eq = function(arg0, arg1) {
        const ret = getObject(arg0) === getObject(arg1);
        return ret;
    };
    imports.wbg.__wbindgen_number_get = function(arg0, arg1) {
        const obj = getObject(arg1);
        const ret = typeof(obj) === 'number' ? obj : undefined;
        getFloat64Memory0()[arg0 / 8 + 1] = isLikeNone(ret) ? 0 : ret;
        getInt32Memory0()[arg0 / 4 + 0] = !isLikeNone(ret);
    };
    imports.wbg.__wbg_isSafeInteger_8c4789029e885159 = function(arg0) {
        const ret = Number.isSafeInteger(getObject(arg0));
        return ret;
    };
    imports.wbg.__wbindgen_error_new = function(arg0, arg1) {
        const ret = new Error(getStringFromWasm0(arg0, arg1));
        return addHeapObject(ret);
    };
    imports.wbg.__wbg_String_91fba7ded13ba54c = function(arg0, arg1) {
        const ret = String(getObject(arg1));
        const ptr1 = passStringToWasm0(ret, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len1 = WASM_VECTOR_LEN;
        getInt32Memory0()[arg0 / 4 + 1] = len1;
        getInt32Memory0()[arg0 / 4 + 0] = ptr1;
    };
    imports.wbg.__wbg_isArray_39d28997bf6b96b4 = function(arg0) {
        const ret = Array.isArray(getObject(arg0));
        return ret;
    };
    imports.wbg.__wbg_length_e498fbc24f9c1d4f = function(arg0) {
        const ret = getObject(arg0).length;
        return ret;
    };
    imports.wbg.__wbg_get_27fe3dac1c4d0224 = function(arg0, arg1) {
        const ret = getObject(arg0)[arg1 >>> 0];
        return addHeapObject(ret);
    };
    imports.wbg.__wbindgen_is_string = function(arg0) {
        const ret = typeof(getObject(arg0)) === 'string';
        return ret;
    };
    imports.wbg.__wbindgen_is_object = function(arg0) {
        const val = getObject(arg0);
        const ret = typeof(val) === 'object' && val !== null;
        return ret;
    };
    imports.wbg.__wbg_entries_4e1315b774245952 = function(arg0) {
        const ret = Object.entries(getObject(arg0));
        return addHeapObject(ret);
    };
    imports.wbg.__wbindgen_string_get = function(arg0, arg1) {
        const obj = getObject(arg1);
        const ret = typeof(obj) === 'string' ? obj : undefined;
        var ptr1 = isLikeNone(ret) ? 0 : passStringToWasm0(ret, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        var len1 = WASM_VECTOR_LEN;
        getInt32Memory0()[arg0 / 4 + 1] = len1;
        getInt32Memory0()[arg0 / 4 + 0] = ptr1;
    };
    imports.wbg.__wbindgen_boolean_get = function(arg0) {
        const v = getObject(arg0);
        const ret = typeof(v) === 'boolean' ? (v ? 1 : 0) : 2;
        return ret;
    };
    imports.wbg.__wbg_call_9495de66fdbe016b = function() { return handleError(function (arg0, arg1, arg2) {
        const ret = getObject(arg0).call(getObject(arg1), getObject(arg2));
        return addHeapObject(ret);
    }, arguments) };
    imports.wbg.__wbg_call_96878afb7a8201ca = function() { return handleError(function (arg0, arg1, arg2, arg3) {
        const ret = getObject(arg0).call(getObject(arg1), getObject(arg2), getObject(arg3));
        return addHeapObject(ret);
    }, arguments) };
    imports.wbg.__wbg_call_99043a1e2a9e5916 = function() { return handleError(function (arg0, arg1, arg2, arg3, arg4) {
        const ret = getObject(arg0).call(getObject(arg1), getObject(arg2), getObject(arg3), getObject(arg4));
        return addHeapObject(ret);
    }, arguments) };
    imports.wbg.__wbg_call_95d1ea488d03e4e8 = function() { return handleError(function (arg0, arg1) {
        const ret = getObject(arg0).call(getObject(arg1));
        return addHeapObject(ret);
    }, arguments) };
    imports.wbg.__wbindgen_string_new = function(arg0, arg1) {
        const ret = getStringFromWasm0(arg0, arg1);
        return addHeapObject(ret);
    };
    imports.wbg.__wbindgen_object_clone_ref = function(arg0) {
        const ret = getObject(arg0);
        return addHeapObject(ret);
    };
    imports.wbg.__wbg_new_abda76e883ba8a5f = function() {
        const ret = new Error();
        return addHeapObject(ret);
    };
    imports.wbg.__wbg_stack_658279fe44541cf6 = function(arg0, arg1) {
        const ret = getObject(arg1).stack;
        const ptr1 = passStringToWasm0(ret, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len1 = WASM_VECTOR_LEN;
        getInt32Memory0()[arg0 / 4 + 1] = len1;
        getInt32Memory0()[arg0 / 4 + 0] = ptr1;
    };
    imports.wbg.__wbg_error_f851667af71bcfc6 = function(arg0, arg1) {
        let deferred0_0;
        let deferred0_1;
        try {
            deferred0_0 = arg0;
            deferred0_1 = arg1;
            console.error(getStringFromWasm0(arg0, arg1));
        } finally {
            wasm.__wbindgen_free(deferred0_0, deferred0_1, 1);
        }
    };
    imports.wbg.__wbg_iterator_55f114446221aa5a = function() {
        const ret = Symbol.iterator;
        return addHeapObject(ret);
    };
    imports.wbg.__wbg_get_baf4855f9a986186 = function() { return handleError(function (arg0, arg1) {
        const ret = Reflect.get(getObject(arg0), getObject(arg1));
        return addHeapObject(ret);
    }, arguments) };
    imports.wbg.__wbindgen_is_function = function(arg0) {
        const ret = typeof(getObject(arg0)) === 'function';
        return ret;
    };
    imports.wbg.__wbg_next_b7d530c04fd8b217 = function(arg0) {
        const ret = getObject(arg0).next;
        return addHeapObject(ret);
    };
    imports.wbg.__wbg_length_27a2afe8ab42b09f = function(arg0) {
        const ret = getObject(arg0).length;
        return ret;
    };
    imports.wbg.__wbindgen_memory = function() {
        const ret = wasm.memory;
        return addHeapObject(ret);
    };
    imports.wbg.__wbg_buffer_cf65c07de34b9a08 = function(arg0) {
        const ret = getObject(arg0).buffer;
        return addHeapObject(ret);
    };
    imports.wbg.__wbg_new_537b7341ce90bb31 = function(arg0) {
        const ret = new Uint8Array(getObject(arg0));
        return addHeapObject(ret);
    };
    imports.wbg.__wbg_set_17499e8aa4003ebd = function(arg0, arg1, arg2) {
        getObject(arg0).set(getObject(arg1), arg2 >>> 0);
    };
    imports.wbg.__wbg_instanceof_Uint8Array_01cebe79ca606cca = function(arg0) {
        let result;
        try {
            result = getObject(arg0) instanceof Uint8Array;
        } catch {
            result = false;
        }
        const ret = result;
        return ret;
    };
    imports.wbg.__wbg_instanceof_ArrayBuffer_a69f02ee4c4f5065 = function(arg0) {
        let result;
        try {
            result = getObject(arg0) instanceof ArrayBuffer;
        } catch {
            result = false;
        }
        const ret = result;
        return ret;
    };
    imports.wbg.__wbindgen_debug_string = function(arg0, arg1) {
        const ret = debugString(getObject(arg1));
        const ptr1 = passStringToWasm0(ret, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len1 = WASM_VECTOR_LEN;
        getInt32Memory0()[arg0 / 4 + 1] = len1;
        getInt32Memory0()[arg0 / 4 + 0] = ptr1;
    };
    imports.wbg.__wbindgen_throw = function(arg0, arg1) {
        throw new Error(getStringFromWasm0(arg0, arg1));
    };

    return imports;
}

function __wbg_init_memory(imports, maybe_memory) {

}

function __wbg_finalize_init(instance, module) {
    wasm = instance.exports;
    __wbg_init.__wbindgen_wasm_module = module;
    cachedBigInt64Memory0 = null;
    cachedFloat64Memory0 = null;
    cachedInt32Memory0 = null;
    cachedUint32Memory0 = null;
    cachedUint8Memory0 = null;


    return wasm;
}

function initSync(module) {
    if (wasm !== undefined) return wasm;

    const imports = __wbg_get_imports();

    __wbg_init_memory(imports);

    if (!(module instanceof WebAssembly.Module)) {
        module = new WebAssembly.Module(module);
    }

    const instance = new WebAssembly.Instance(module, imports);

    return __wbg_finalize_init(instance, module);
}

async function __wbg_init(input) {
    if (wasm !== undefined) return wasm;

    if (typeof input === 'undefined') {
        input = new URL('rose_web_bg.wasm', import.meta.url);
    }
    const imports = __wbg_get_imports();

    if (typeof input === 'string' || (typeof Request === 'function' && input instanceof Request) || (typeof URL === 'function' && input instanceof URL)) {
        input = fetch(input);
    }

    __wbg_init_memory(imports);

    const { instance, module } = await __wbg_load(await input, imports);

    return __wbg_finalize_init(instance, module);
}

export { initSync }
export default __wbg_init;
